/**
 * LP Cart Button — listens for `cart:updated` events and refreshes the
 * item-count badge on every [data-lp-cart-btn] on the page. Pulses the
 * badge briefly when the count changes so the user notices the update.
 *
 * The AJAX add-to-cart flow in landing-bracelet-black-men.js already
 * dispatches the event with `event.detail.cart` (parsed /cart.json), so
 * this module just consumes it.
 *
 * Initial count is rendered server-side via Liquid — no fetch on load.
 */
(function () {
  'use strict';

  function pluralLabel(n) {
    return 'View cart, ' + n + ' item' + (n === 1 ? '' : 's');
  }

  function updateBadge(count) {
    if (typeof count !== 'number' || count < 0) return;
    var btns = document.querySelectorAll('[data-lp-cart-btn]');
    btns.forEach(function (btn) {
      var badge = btn.querySelector('[data-lp-cart-count]');
      btn.setAttribute('aria-label', pluralLabel(count));
      if (!badge) return;

      var prev = parseInt(badge.textContent, 10);
      if (isNaN(prev)) prev = 0;

      badge.textContent = String(count);

      if (count <= 0) {
        badge.setAttribute('hidden', '');
        return;
      }
      badge.removeAttribute('hidden');

      // Only pulse when the count actually changed (skip initial render
      // where prev === count, and skip "still zero" no-ops).
      if (count !== prev) {
        badge.classList.remove('is-pulse');
        // Force reflow so the animation re-fires when the class is re-added.
        // eslint-disable-next-line no-unused-expressions
        badge.offsetHeight;
        badge.classList.add('is-pulse');
        setTimeout(function () { badge.classList.remove('is-pulse'); }, 500);
      }
    });
  }

  document.addEventListener('cart:updated', function (e) {
    if (e && e.detail && e.detail.cart && typeof e.detail.cart.item_count === 'number') {
      updateBadge(e.detail.cart.item_count);
    }
  });
})();
